import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, fmt } from "@/lib/api";
import { ConfidenceBadge } from "@/components/ConfidenceBadge";
import { Card } from "@/components/ui/card";
import { FileBarChart, ArrowRight, Loader2, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Assignments() {
  const [calcs, setCalcs] = useState(null);
  useEffect(() => { api.get("/calculations").then((r) => setCalcs(r.data)); }, []);
  if (!calcs) return <div className="p-8 flex items-center gap-2 text-muted-foreground"><Loader2 className="h-5 w-5 animate-spin" /> Loading…</div>;

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto animate-fade-up">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#B45309] font-semibold">Calculations</div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900">My Assignments</h1>
        </div>
        <Link to="/calculator"><Button className="bg-essred hover:bg-essred-700 text-white" data-testid="new-calc-btn"><Plus className="h-4 w-4 mr-2" /> New calculation</Button></Link>
      </div>

      {calcs.length === 0 ? (
        <Card className="mt-6 p-10 bg-white text-center text-muted-foreground" data-testid="assignments-empty">
          <FileBarChart className="h-10 w-10 mx-auto text-slate-600 mb-3" />
          No calculations yet. Start from the Calculator.
        </Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-4 mt-6" data-testid="assignments-grid">
          {calcs.map((c) => {
            const s = c.result.summary;
            return (
              <Link key={c.calculation_id} to={`/assignment/${c.calculation_id}`} data-testid={`assignment-card-${c.calculation_id}`}
                className="rounded-xl border bg-white p-5 exec-shadow hover:border-[#F5A623] transition-colors block">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="font-display font-bold text-slate-900">{c.employee_name}</div>
                    <div className="text-sm text-muted-foreground">{c.result.base_location.city} → {c.result.host_location.city}</div>
                  </div>
                  <ConfidenceBadge level={c.result.confidence} />
                </div>
                <div className="mt-4 grid grid-cols-3 gap-3 text-sm">
                  <div><div className="text-xs text-muted-foreground">COLA</div><div className={`font-mono font-semibold ${s.cola.positive ? "text-emerald-600" : "text-essred"}`}>{(s.cola.pct * 100).toFixed(1)}%</div></div>
                  <div><div className="text-xs text-muted-foreground">Employer Cost</div><div className="font-mono font-semibold text-slate-900">{fmt(s.total_employer_cost.usd, "USD")}</div></div>
                  <div><div className="text-xs text-muted-foreground">Status</div><div className="font-medium">{c.status}</div></div>
                </div>
                <div className="mt-3 flex items-center gap-1 text-essred text-sm font-semibold">Open <ArrowRight className="h-3.5 w-3.5" /></div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
